<template>
    <!--
        The prototype's customizer, as a preview tool.

        It changes this browser and nothing else: the house's real look is a setting the
        reception saves (PUT /properties/{id}/portal), and a guest's token has no right
        to write it. Whoever is designing opens the portal with ?studio, tries colours
        here, and hands the values to the reception screen.
    -->
    <div class="modalbg" :class="{ open: props.open }" @click.self="close">
        <div class="modal">
            <h2>{{ $t('studio.title') }}</h2>
            <p class="muted">{{ $t('studio.hint') }}</p>

            <div class="form" style="margin-top:14px">
                <div>
                    <label class="muted">{{ $t('studio.primary') }}</label>
                    <div class="swatches">
                        <button
                            v-for="colour in primaries"
                            :key="colour"
                            class="swatch"
                            :style="{ background: colour }"
                            @click="setVar('--n', colour)"
                        />
                    </div>
                </div>
                <div>
                    <label class="muted">{{ $t('studio.accent') }}</label>
                    <div class="swatches">
                        <button
                            v-for="colour in accents"
                            :key="colour"
                            class="swatch"
                            :style="{ background: colour }"
                            @click="setVar('--o', colour)"
                        />
                    </div>
                </div>
            </div>

            <div style="margin-top:14px">
                <label>
                    <input type="checkbox" @change="compact($event)"> {{ $t('studio.compact') }}
                </label>
            </div>

            <div class="actions">
                <button class="secondary" @click="close">{{ $t('general.close') }}</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useI18n } from 'vue-i18n'

    import { toast } from '@/libs/toast'

    const { t } = useI18n()

    const props = defineProps<{ open: boolean }>()
    const emit = defineEmits<((e: 'update:open', value: boolean) => void)>()

    const primaries = ['#082f40', '#234b3b', '#60323d', '#213f70']
    const accents   = ['#ff9238', '#c59a45', '#27a69a']

    const setVar = (name: string, colour: string) => {
        document.documentElement.style.setProperty(name, colour)
        toast(t('studio.preview_only'))
    }

    const compact = (event: Event) => {
        document.body.classList.toggle('compact', (event.target as HTMLInputElement).checked)
    }

    const close = () => emit('update:open', false)
</script>
